import { palette } from "./palette";

/**
 * Roles for colors.  Prefer using these over the palette.  It makes it easier
 * to change things.
 *
 * The only roles we need to place in here are the ones that span through the app.
 *
 * If you have a specific use-case, like a spinner color.  It makes more sense to
 * put that in the <Spinner /> component.
 */
export const colors = {
  /**
   * The palette is available to use, but prefer using the name.
   */
  palette,
  /**
   * A helper for making something see-thru. Use sparingly as many layers of transparency
   * can cause older Android devices to slow down due to the excessive compositing required
   * by their under-powered GPUs.
   */
  transparent: "rgba(0, 0, 0, 0)",
  /**
   * The screen background.
   */
  background: palette.white,
  /**
   * The main tinting color.
   */
  primary: palette.orange,
  /**
   * The main tinting color, but darker.
   */
  primaryDarker: palette.orangeDarker,
  /**
   * A subtle color used for borders and lines.
   */
  line: palette.offWhite,
  /**
   * The default color of text in many components.
   */
  text: palette.black,
  /**
   * Secondary information.
   */
  dim: palette.lightGrey,
  /**
   * Error messages and icons.
   */
  error: palette.angry,
  /** Colors for the background of the info box */
  lightInfo: palette.lighterBlue,
  lightWarning: palette.lighterOrange,
  lightError: palette.lighterRed,
  lightSuccess: palette.lighterGreen,

  /**
   * Storybook background for Text stories, or any stories where
   * the text color is color.text, which is white by default, and does not show
   * in Stories against the default white background
   */
  link: palette.lightBlue,
  white: palette.white,
  grey: palette.grey,
  green: palette.green,
  darkBg: palette.darkBlue,
  stepperGrey: palette.mediumGrey,
  lightGrey: palette.lighterGrey,
  lightestGrey: palette.lightestGrey,
  darkGrey: palette.darkGrey,
  lightBlue: palette.lighterBlue,
  darkBackgroundText: palette.black,
  translucent: "rgba(255, 255, 255, 0.21)",
  red: palette.red,
  inputNavigation: palette.inputNavigation,
  purple: palette.purple,


  /**
   * Colors for rebrand
  */
 rebrand:{
  brandOrange: "#F26924",
  royalBlue: "#0B1336",
  lightestBlue: "#E6F0FA",
  specialGrey: "#666666",
  disabledGrey: "#999999",
  lightGrey: "#CCCCCC",
  darkGrey: "#1E1E1E",
 }

};
